import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-phone-number-element',
  templateUrl: './phone-number-element.component.html',
  styleUrls: ['./phone-number-element.component.scss'],
})
export class PhoneNumberElementComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
